import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Rightward"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M631.780986 486.259831L139.404679 9.174714c-12.232952-12.232952-32.621205-12.232952-44.854156 0-12.232952 12.232952-12.232952 31.601792 0 43.325037l470.458934 455.677452L88.943753 968.442011c-12.232952 12.232952-12.232952 31.601792 0 43.325037 12.232952 12.232952 32.621205 12.232952 44.854156 0l497.983077-482.18218c12.742658-11.723245 12.742658-31.601792 0-43.325037z m0 0M913.648581 1024h-1.019412c-16.820309 0-30.582379-13.762071-30.58238-30.582379V33.130911c0-16.820309 13.762071-30.582379 30.58238-30.582379h1.019412c16.820309 0 30.582379 13.762071 30.58238 30.582379v960.28671c0 16.820309-13.762071 30.582379-30.58238 30.582379z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var rightward = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\rightward.vue"]]);

export { rightward as default };
